import React, { FC, JSX } from 'react';

import { AzureIssueCreatorFormUI, EvPopup } from '@evinced-private/ui-common';

import { useAzureIssueForm } from '../AzureTicketCreatorHooks';
import {
	ALERT_POPUP_TITLE,
	AZURE_NOT_CONNECTED_MESSAGE,
	ISSUE_FORM_TITLE
} from '../consts/AzureConstants';
import { IAzureIssueCreatorProps } from '../types/AzureIssueCreator.types';

import './AzureIssueCreator.scss';

const AzureIssueCreator: FC<IAzureIssueCreatorProps> = (props): JSX.Element => {
	const { closeModal, isOpen } = props;
	const {
		isLoading,
		alertModalOpen,
		appElement,
		buttons,
		host,
		projects,
		selectedProject,
		issueTypes,
		selectedIssueType,
		fields,
		screenshotUrl,
		updateField,
		onChangeProjectPicker,
		onChangeIssueTypePicker,
		isPublishButtonDisabled,
		onCreateIssueClicked
	} = useAzureIssueForm(props);

	if (!host && alertModalOpen) {
		return (
			<EvPopup
				appElement={appElement}
				title={ALERT_POPUP_TITLE}
				buttons={buttons}
				isControlled
				isCentered
				isOpen={alertModalOpen}
				className="error-popup"
				onClose={closeModal}
				popupWidth="100%"
			>
				<div className="alert-popup">{AZURE_NOT_CONNECTED_MESSAGE}</div>
			</EvPopup>
		);
	}

	return (
		<EvPopup
			appElement={appElement}
			title={ISSUE_FORM_TITLE}
			isOpen={isOpen}
			popupWidth="100%"
			className="azure-popup"
			isBgTransparent
			isControlled
			onClose={closeModal}
		>
			<AzureIssueCreatorFormUI
				title=""
				isLoading={isLoading}
				projects={projects}
				selectedProject={selectedProject}
				issueTypes={issueTypes}
				selectedIssueType={selectedIssueType}
				fields={fields}
				screenshotUrl={screenshotUrl}
				onChangeProjectPicker={onChangeProjectPicker}
				onChangeIssueTypePicker={onChangeIssueTypePicker}
				updateField={updateField}
				isPublishButtonDisabled={isPublishButtonDisabled}
				onCreateIssueClicked={onCreateIssueClicked}
				closeModal={closeModal}
			/>
		</EvPopup>
	);
};

export { AzureIssueCreator };
